import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { FormActivityInputViewComponent } from '../../form-activity-editor/form-activity-input/form-activity-input-view/form-activity-input-view.component';

@Component({
  selector: 'wm-continuous-activity-input',
  templateUrl: './continuous-activity-input.component.html',
  styleUrl: './continuous-activity-input.component.css',
  standalone: false
})
export class ContinuousActivityInputComponent  extends ActivityView
  implements OnInit {

  @ViewChild('formActivityInputView', { static: false })
  formActivityInputViewCtl: FormActivityInputViewComponent; 
  
  constructor() {
    super();
  }

  ngOnInit() { }

  async persistChildComponent() {
    return this.formActivityInputViewCtl.persistChildComponent();
  }
}
